// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"f6fed92f","417":"eb1369fd","504":"be72d7a0","656":"e29690aa","828":"0479de95"}[chunkId] + ".chunk.js";
};